import { render } from "./FrmWeighingSystem.vue?vue&type=template&id=23784ba0"
import script from "./FrmWeighingSystem.vue?vue&type=script&lang=js"
export * from "./FrmWeighingSystem.vue?vue&type=script&lang=js"

import "./FrmWeighingSystem.vue?vue&type=style&index=0&id=23784ba0&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__